import React, { useState } from 'react';
import api from '@/lib/api';
import { BASE, Box, inp, useGet, Pager } from './ui';
import { Metricas, Testes } from './CargaBackupTab';
import { ConsultaAluno, n, Secao, Tabela } from './ConsultaAluno';

const Q = `${BASE}/consulta`;
const SUB = [['painel', 'Painel'], ['alunos', 'Alunos'], ['responsaveis', 'Responsáveis'], ['turmas', 'Turmas por ano'], ['cursos', 'Cursos e matrizes'], ['disciplinas', 'Disciplinas e avaliação'], ['pendencias', 'Pendências']];
const ANOS = Array.from({ length: 16 }, (_, i) => 2010 + i);

function Painel() {
  const d = useGet(`${Q}/painel`);
  if (!d) return <p className="text-sm text-slate-500">Carregando…</p>;
  return (
    <div className="space-y-3" data-testid="consulta-painel">
      <Metricas p={d} />
      <Secao t="Indicadores" testid="consulta-indicadores">
        <p className="text-xs">Alunos completos: <b>{n(d.alunos_completos)}</b> de {n(d.alunos)} · não conciliados com o DNACore: <b className="text-amber-700" data-testid="consulta-nao-conciliados">{n(d.nao_conciliados_dnacore)}</b></p>
        <p className="text-xs">Pendências dos alunos: {Object.entries(d.alunos_pendencias).map(([k, v]) => `${k.replaceAll('_', ' ')} ${n(v)}`).join(' · ') || 'nenhuma'}</p>
        <p className="text-xs">Turmas por ano: {Object.entries(d.turmas_por_ano).map(([k, v]) => `${k}: ${v}`).join(' · ')}</p>
        <Testes t={d.testes} testid="consulta-testes" />
      </Secao>
    </div>
  );
}

function Busca({ url, render, testid, extra }) {
  const [q, setQ] = useState('');
  const [d, setD] = useState(null);
  const ir = (params) => api.get(url, { headers: q ? { 'X-Acervo-Busca': encodeURIComponent(q.trim()) } : {}, params }).then(({ data }) => setD(data)).catch((e) => setD({ erro: e?.response?.data?.detail || 'Erro.' }));
  return (
    <Box testid={testid}>
      <div className="flex flex-wrap gap-2">
        <input className={`${inp} w-72`} placeholder="Nome completo ou parte (mín. 3 letras)" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && ir()} data-testid={`${testid}-input`} />
        <button type="button" className="rounded-full bg-slate-900 px-4 py-1 text-xs font-semibold text-white" onClick={() => ir()} data-testid={`${testid}-buscar`}>Buscar</button>
        {extra && <button type="button" className="rounded-full border px-4 py-1 text-xs font-semibold" onClick={() => ir(extra.params)} data-testid={`${testid}-extra`}>{extra.label}</button>}
      </div>
      {d?.erro && <p className="mt-2 text-xs text-rose-700">{d.erro}</p>}
      {d?.items && (d.items.length ? render(d.items) : <p className="mt-2 text-xs text-slate-500" data-testid={`${testid}-vazio`}>Nenhum resultado.</p>)}
    </Box>
  );
}

function Alunos() {
  const [sel, setSel] = useState(null);
  if (sel) return <ConsultaAluno id={sel} voltar={() => setSel(null)} />;
  return (
    <Busca url={`${Q}/alunos`} testid="consulta-busca-aluno" extra={{ label: 'Somente pendentes', params: { pendentes: true } }} render={(items) => (
      <ul className="mt-2 divide-y text-sm" data-testid="consulta-alunos-lista">{items.map((a) => (
        <li key={a._id} className="flex flex-wrap items-center gap-2 py-1.5">
          <button type="button" className="font-semibold text-sky-800 hover:underline" onClick={() => setSel(a._id)} data-testid={`consulta-aluno-${a._id}`}>{a.nome || `Sem nome (AlunoID ${a._id})`}</button>
          <span className="text-xs text-slate-500">{a.anos?.length ? `${a.anos[0]}–${a.anos[a.anos.length - 1]}` : 'sem turma'} · {a.turmas} turma(s)</span>
          {!a.completo && <span className="rounded bg-amber-100 px-1.5 text-[10px] font-bold text-amber-800">{a.pendencias.join(', ')}</span>}
          {a.conciliacao_dnacore !== 'VINCULADO' && <span className="rounded bg-slate-100 px-1.5 text-[10px] text-slate-600">não conciliado</span>}
        </li>))}</ul>)} />
  );
}

const Responsaveis = () => (
  <Busca url={`${Q}/responsaveis`} testid="consulta-busca-responsavel" render={(items) => (
    <ul className="mt-2 divide-y text-sm" data-testid="consulta-responsaveis-lista">{items.map((r) => (
      <li key={r._id} className="py-1.5"><b>{r.nome}</b> <span className="text-xs text-slate-500">· {r.n_alunos} aluno(s): {r.alunos.map((a) => a.nome || a.aluno_id).join(', ') || '—'}</span></li>))}</ul>)} />
);

function Turmas() {
  const [ano, setAno] = useState(2015);
  const d = useGet(`${Q}/turmas`, { ano });
  return (
    <Box testid="consulta-turmas">
      <select className={inp} value={ano} onChange={(e) => setAno(Number(e.target.value))} data-testid="consulta-turmas-ano">{ANOS.map((y) => <option key={y} value={y}>{y}</option>)}</select>
      {d && <p className="my-2 text-xs text-slate-600">{d.items?.length} turma(s) · {Object.entries(d.regimes || {}).map(([k, v]) => `${k} ${v}`).join(' · ')}</p>}
      {d?.items && <Tabela rows={d.items} cols={[['turma', 'Turma'], ['curso', 'Curso'], ['regime', 'Regime'], ['situacao', 'Situação'], ['matriculas', 'Matrículas']]} testid="consulta-turmas-tabela" />}
    </Box>
  );
}

function Cursos() {
  const d = useGet(`${Q}/cursos`);
  const [g, setG] = useState(null);
  const m = useGet(g ? `${Q}/matriz` : null, { grade: g });
  if (!d) return <p className="text-sm text-slate-500">Carregando…</p>;
  return (
    <div className="space-y-3">
      <Secao t={`Cursos (${d.cursos.length})`} testid="consulta-cursos"><Tabela rows={d.cursos} cols={[['nome', 'Curso'], ['regime', 'Regime'], ['ativo', 'Ativo']]} testid="consulta-cursos-tabela" /></Secao>
      <Secao t={`Matrizes curriculares (${d.matrizes.length})`} testid="consulta-matrizes">
        <ul className="grid gap-1 text-xs sm:grid-cols-2">{d.matrizes.map((x) => (
          <li key={x.grade_id}><button type="button" className="text-left text-sky-800 hover:underline" onClick={() => setG(x.grade_id)} data-testid={`consulta-matriz-${x.grade_id}`}>{x.nome}</button> <span className="text-slate-500">· {x.regime || '—'} · {x.disciplinas} disc. · {x.turmas} turma(s)</span></li>))}</ul>
        {g && m?.items && <div className="mt-3"><Tabela rows={m.items} cols={[['disciplina', 'Disciplina'], ['etapa', 'Etapa'], ['carga_horaria', 'Carga horária'], ['sistema_avaliacao', 'Sistema de avaliação']]} testid="consulta-matriz-tabela" /></div>}
      </Secao>
    </div>
  );
}

function Disciplinas() {
  const d = useGet(`${Q}/disciplinas`);
  if (!d) return <p className="text-sm text-slate-500">Carregando…</p>;
  return (
    <div className="space-y-3">
      <Secao t={`Sistemas de avaliação (${d.sistemas_avaliacao.length})`} testid="consulta-sistemas">
        <Tabela rows={d.sistemas_avaliacao} cols={[['Nome', 'Nome'], ['NomePeriodo', 'Período'], ['MediaMinima', 'Média mínima'], ['MediaExame', 'Média exame'], ['Recuperacao', 'Recuperação'], ['FrequenciaMinima', 'Freq. mínima']]} testid="consulta-sistemas-tabela" />
      </Secao>
      <Secao t={`Disciplinas (${d.disciplinas.length})`} testid="consulta-disciplinas"><div className="max-h-96 overflow-auto"><Tabela rows={d.disciplinas} cols={[['nome', 'Disciplina'], ['sigla', 'Sigla'], ['ativo', 'Ativo']]} testid="consulta-disciplinas-tabela" /></div></Secao>
    </div>
  );
}

function Pendencias() {
  const [tipo, setTipo] = useState('');
  const [pagina, setPagina] = useState(1);
  const d = useGet(`${Q}/pendencias`, { ...(tipo ? { tipo } : {}), pagina });
  return (
    <Box testid="consulta-pendencias">
      <select className={inp} value={tipo} onChange={(e) => { setTipo(e.target.value); setPagina(1); }} data-testid="consulta-pendencias-tipo">
        <option value="">Todos os tipos</option>{Object.entries(d?.tipos || {}).map(([k, v]) => <option key={k} value={k}>{k} ({v})</option>)}</select>
      {d?.items && <table className="mt-2 w-full text-[11px]"><tbody>{d.items.map((i, k) => <tr key={k} className="border-t align-top"><td className="p-1 font-bold">{i.tipo}</td><td className="p-1">{i.chave}</td><td className="break-all p-1 text-slate-600">{JSON.stringify(i.detalhe)}</td></tr>)}</tbody></table>}
      <Pager d={d} pagina={pagina} setPagina={setPagina} testid="consulta-pendencias-pager" />
    </Box>
  );
}

const VIEWS = { painel: Painel, alunos: Alunos, responsaveis: Responsaveis, turmas: Turmas, cursos: Cursos, disciplinas: Disciplinas, pendencias: Pendencias };

export function ConsultaTab() {
  const [s, setS] = useState('painel');
  const V = VIEWS[s];
  return (
    <div className="space-y-3" data-testid="consulta-tab">
      <div className="flex flex-wrap gap-1.5">{SUB.map(([k, l]) => <button key={k} type="button" onClick={() => setS(k)} data-testid={`consulta-sub-${k}`}
        className={`rounded-lg px-3 py-1 text-xs font-semibold transition-colors ${s === k ? 'bg-amber-900 text-amber-50' : 'bg-amber-50 text-amber-900 hover:bg-amber-100'}`}>{l}</button>)}</div>
      <p className="text-[11px] text-slate-500">Financeiro, fiscal e demais tabelas do backup: aba “Financeiro, responsáveis e demais”. Passe o mouse em “origem” para ver arquivo, tabela, linha, ID e hash.</p>
      <V />
    </div>
  );
}
